export default "/images/f878ec1b061b82a4356e9108ae822344.avif";